import { StepperStep } from '@/components/NewGeneralDialog/DialogStepper';
import {
  DOCUMENTABLE_TYPE_MAP,
  MAPPED_ORDER_STATUS,
  ORDER_EVENT,
  ORDER_STATUS,
  OrderType,
} from '@treyd-io/shared/constants/orders';
import { TFunction } from 'i18next';

export enum InvoicingEmailError {
  DUPLICATE_EMAIL = 'DUPLICATE_EMAIL',
}

export const ORDER_STEPS = (
  t: TFunction<'appNS', undefined, 'appNS'>
): StepperStep[] => [
  {
    label: t('create'),
    status: 'not_completed',
  },
  {
    label: t('review'),
    status: 'not_completed',
  },
  {
    label: t('confirm'),
    status: 'not_completed',
  },
];

export enum VERIFICATION_METHOD {
  SMS = 'sms_otp',
  BANKID_SE = 'bankid_se',
  BANKID_NO = 'bankid_no',
  BANKID_FI = 'bankid_fi',
}

export const ERROR_FREE_MESSAGES = ['new', 'started', 'complete', 'sent'];

export const CUTOFF_INVOICE_REPAYMENT_DUE_DAYS = 7;

export const UPDATING_ORDER_DELAY = 1000;

export {
  DOCUMENTABLE_TYPE_MAP,
  MAPPED_ORDER_STATUS,
  ORDER_EVENT,
  ORDER_STATUS,
  OrderType,
};
